enum ArrivalType {
    PreviousPartyLeaves = 1,
    AddToCurrentParty = 2
}

export default ArrivalType;